<div class="row m-0 available-activities">
    <div class="col-lg-3 col-md-4 p-0">
        <div class="reservation-filter-layout">
            <app-activity-filter (filterData)="loadClassActivities($event)" (resetData)="assignResetData($event)">
            </app-activity-filter>
        </div>
    </div>
    <div class="col-lg-9 col-md-8 p-0">
        <div class="banner-scrool">
        <div class="activity__banner-image" [ngClass]="{'layout__banner-image-height':activityService.hideImage}" *ngIf="!activityService.hideImage">
            <img src="{{activityService.imageUrl}}"  (error)="activityService.loadDefaultImage($event)" alt="banner-img" >
        </div>
        <div class="activity-selector column">
            <div class="row m-0">
                <div class="col-lg-6 col-md-6 p-0">

                    <div class="actvity-sub-title">
                        {{'SelectanavailableClass' | translate}}
                    </div>
                </div>

                <div class=" col-lg-6 col-md-6 row">
                    <div class="col-lg-4 col-md-4 grid-view"> <span class="icon-grid1"
                            [ngClass]="{'active':isListView !== true }" (click)="changeView(false)"></span> <span
                            class="icon-view-list" [ngClass]="{'active':isListView === true }"
                            (click)="changeView(true)"> </span></div>

                    <div class="search-filter col-lg-8 col-md-8 pe-0">
                        <dynamic-form [config]="search_config" #form="dynamicForm">
                        </dynamic-form>
                    </div>
                </div>
                <ng-container *ngIf="availableActivities.length > 0;">
                    <div class="col-lg-12 col-md-12" *ngIf="!isListView">
                        <div class="legends">
                            <div class="legends-list">
                                <span class="dot">
                                    &nbsp;
                                </span>
                                {{ 'NotAvailable' | translate }}
                            </div>
                            <div class="legends-list">
                                <span class="dot"> &nbsp;
                                </span>
                                {{ 'available' | translate }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <ng-container *ngIf="availableActivities.length > 0; else availableResultBlock">


                <div *ngIf="!isListView">
                    <div class="avail-container">
                        <div class="activity-box" *ngFor="let class of availableActivities;let index = index"
                            [ngStyle]="class.Color != null ?{'border':'3px solid rgba('+class.Color.R+','+class.Color.G+','+class.Color.B+','+class.Color.A+')'}: ''"
                            (click)="selectedClassActivity(class)"
                            [ngClass]="{'slot-disabled' : class.Availability === 'Not Available'}">
                            <div class="title ellipsis-text" title="{{class.LessonName}}">
                                {{class.LessonName}}
                            </div>
                            <div class="location ellipsis-text" title="{{class.LocationName}}">
                                {{class.LocationName}}
                            </div>
                            <div class="available">
                                {{class.Availability}}
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isListView" class="table-container">

                    <mat-table [dataSource]="filterDataGridList" class="list-container" matSort matSortDisableClear>
                        <ng-container matColumnDef="{{column.field}}" *ngFor="let column of cols;let i =index">
                            <th  mat-header-cell *matHeaderCellDef class="table-header pt-2"
                                [style.width]="column.style.width" [hidden]="!column.availability">
                                {{column.header | translate}}
                                <!-- <span class="fa fa-sort"></span> -->
                            </th>
                            <td mat-cell *matCellDef="let element" [style.width]="column.style.width" [hidden]="!column.availability"
                                [class.alignRight]="column.alignRight" [class.alignCenter]="column.alignCenter" >
                                <span title="{{element[column.field]}}" *ngIf="column.isDate">{{element[column.field] |
                                    date:'MM/dd/yyyy'}}</span>
                                <span title="{{element[column.field]}}"
                                    *ngIf="!column.isDate && !column.isCurrency">{{element[column.field]}}</span>
                                    <span title="{{element[column.field]}}"
                                    *ngIf="column.isCurrency && element[column.field]">{{activityService.OperationCurrency}}{{element[column.field]| currencyDecimalFormatter}}</span>
                                <span title="{{element[column.field]}}"
                                    *ngIf="column.isCurrency && !element[column.field]">{{activityService.OperationCurrency}}{{ 0 | currencyDecimalFormatter}}</span>
                            </td>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef=" columnsToDisplay"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplay; let index = index;"
                            [ngClass]="row['Availability'] === 'Available'? 'cursor-pointer': 'cursor-blocked'"
                            (click)="selectedItem(row, index)">
                        </mat-row>
                    </mat-table>
                    <div class="no-records row" *ngIf="filterDataGridList && !filterDataGridList.filteredData.length">
                        {{'Noclassavailable' | translate}}</div>
                </div>
            </ng-container>
            <ng-template #availableResultBlock>
                <p class="no-avail">{{'Noclassavailable' | translate}}</p>
            </ng-template>
        </div>
    </div>
    </div>
</div>